import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Chip, Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import OptionCard from '../option-card';
import StepActions from '../step-actions';
import StepLayout from '../step-layout';

interface Props {
  linkedinContracts: string[];
  selectedContract: string | null;
  updateLoading: boolean;

  handleSelectContract(contract: string): () => void;

  handleAddContractFromAppSync(): void;
}

/**
 * Die einzige zweite Stelle, an der der Kunde selbst dran ist: mehrere Recruiter- oder
 * Sales-Navigator-Verträge auf einem Konto, und wir dürfen nicht raten, mit welchem
 * gearbeitet wird.
 */
const ChooseContract: React.FC<Props> = ({
  linkedinContracts,
  selectedContract,
  updateLoading,
  handleSelectContract,
  handleAddContractFromAppSync,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <StepLayout
      title={t('appSyncChooseContractTitle', 'Welchen Vertrag sollen wir nutzen?')}
      description={t('appSyncChooseContractDescription', 'Dein Konto hat mehrere Verträge. Wähle den, mit dem wir arbeiten sollen.')}
      footer={
        <StepActions
          primaryText={t('appSyncApplyContract', 'Übernehmen')}
          primaryLoading={updateLoading}
          primaryDisabled={!selectedContract}
          onPrimary={handleAddContractFromAppSync}
        />
      }
    >
      <Stack gap={1.5}>
        <Stack direction={'row'}>
          <Chip className={classes.actionChip} icon={<AssignmentIndIcon />} label={t('appSyncYourChoice', 'Kurz deine Auswahl')} />
        </Stack>
        {linkedinContracts.map((contract) => (
          <OptionCard
            key={contract}
            title={contract}
            selected={contract === selectedContract}
            onSelect={handleSelectContract(contract)}
          />
        ))}
      </Stack>
    </StepLayout>
  );
};

const useStyles = makeStyles()((theme) => ({
  actionChip: {
    background: theme.palette.backgrounds.lightOrange,
    color: theme.palette.warning.dark,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    '& .MuiChip-icon': {
      color: theme.palette.warning.dark,
      fontSize: theme.typography.pxToRem(15),
    },
  },
}));

export default ChooseContract;
